// extracted by mini-css-extract-plugin
export default {"container":"YnuxyEsxEM5KocayMY9I","left":"RlTHp2PUW6ZvH6NWhRbm","right":"FwYzJhYNUSp_IPJoVkom","icon":"xHC_W4L0lWuJgMsyRPuT"};